const StorageConstants = {
  LoginStatusApiKey: 'loginApiStatus',
  LanguageCode: 'en',
  Filter: 'gameFilter',
  UserUuid: 'userUuid',
  Email: 'email'
}

export default StorageConstants
